import Http from '../http/backoffice';
import HttpTmed from '../http/tmed';
import { serialize } from '@/util';
// eslint-disable-next-line

// UNIFIED QUEUE
export const listQueue = () => Http.get(`/queue`);
export const newMeet = (param) => Http.post(`/queue/pick`, param);

// export const queue = () => Http.get(`/admin/calendar?limit=50`);
export const listSchedules = (param) => Http.get(`/slots/date${serialize(param)}`);

// PESQUISA POR NOME OU CPF?
export const searchPatient = (param) =>
  Http.get(
    `/user-schedule-queue?${param.type}=${param.value}&limit=${param.limit}${
      param.partner ? `&partner=${param.partner}` : ''
    }`
  );
export const searchAllSchedules = (param) => Http.get(`/schedules/all${serialize(param)}`);
export const meetInProgress = () => Http.get(`/meets/my`);
// export const avarageTime = () => Http.get(`/queue/status`);

// RELATÓRIO DE AGENDAMENTOS
export const reportSchedules = (param) =>
  Http.post(`/report/${param.initial}/${param.final}?${param.partner ? `partner=${param.partner}` : ''}`);

// OVERBOOKING QUEUE
export const checkDoctorQueue = () => HttpTmed.get(`/check/doctor/queue`);
export const openDoctorQueue = () => HttpTmed.post(`/doctor/queue`);
export const closeDoctorQueue = () => HttpTmed.put(`/doctor/queue/close`);
export const pullPatientFromQueue = (cpf) => HttpTmed.put(`/doctor/queue/pick/${cpf}`);
// Inform patient about delay
export const informPatientDelay = (cpf, payload) => HttpTmed.put(`/doctor/delay/${cpf}`, payload);
let wsEnviroment = 'wss://0331st63ck.execute-api.us-east-1.amazonaws.com/prd';
if (location.hostname.includes('localhost') || location.hostname.includes('dev-')) {
  wsEnviroment = 'wss://iqr2gw7bmc.execute-api.us-east-1.amazonaws.com/dev';
} else if (location.hostname.includes('uat-')) {
  wsEnviroment = 'wss://pidlh2k6y3.execute-api.us-east-1.amazonaws.com/uat';
} else if (location.hostname.includes('partner-')) {
  wsEnviroment = 'wss://pidlh2k6y3.execute-api.us-east-1.amazonaws.com/ppr';
}
export const wsUrl = wsEnviroment;
